Librarian.Modules.Contacts = new Class({
    Extends: Librarian.Modules.Module,

    options: {
        classPrefix: "modules-contacts-",
        eventId: null,
        archived: true
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function() {
        if (!this.wrapperEl || (typeof this.options.eventId != "number"))
            return;

        this.parent();

        var listEl = new Element("ul").injectInside(this.containerEl);

        this.request = Librarian.Events.getEventRecipients(this.options.eventId, this.options.archived, "ujson", function(json) {
            if (!json)
                return;

            for (var i = 0, length = json.length; i < length; i++) {
                var listItemEl = new Element("li", {
                        "class": (this.options.classPrefix || '') + "item"
                    }).injectInside(listEl),
                    chevronEl = new Element("span", {
                        "class": "entypo-right-open"
                    });

                new Element("span", {
                    "text": json[i].DisplayName,
                    "class": (this.options.classPrefix || '') + "name"
                }).injectInside(listItemEl);

                if (json[i].DisplayName != json[i].Email) {
                    new Element("span", {
                        "text": json[i].Email,
                        "class": (this.options.classPrefix || '') + "email"
                    }).injectInside(listItemEl);
                }

                chevronEl.injectInside(listItemEl);

                listItemEl.client = Librarian.Contacts.getContactFromJSON(Object.toLowerKeys(json[i]));
                listItemEl.addOnClick(function () {
                    var win = new Librarian.ContactDetailWindow(this.client, {
                        id: "ContactDetailWindow" + (new Date().getTime()),
                        index: contactDetailWindows.length,
                        onCloseComplete: function() {
                            contactDetailWindows.remove(this.options.index);

                            for (var i = 0; i < contactDetailWindows.length; i++)
                                contactDetailWindows[i].options.index = i;
                        }
                    });

                    contactDetailWindows.push(win);
                });
            }
        }.bind(this));
    }
});